import React, {
	useState,
	useEffect,
	useCallback,
	//useMemo,
} from 'react';

import {
 	useSelector,
 	useDispatch
} from 'react-redux';

import Loading from 'components/loading.js'

//import { GenericListSelect } from 'components/genericListSelect.js'
//import { GenericDictSelect } from './genericDictSelect.js'
import {
	actionSetMessage,
	//actionResetMessages
} from 'components/messages/actions.js';
import { actionFetchWeigherIds } from './actions.js';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

export const WeigherIdSelect = (props) => {

	//const [weighers, setWeighers] = useState([{'WeigherID': '66', 'xname': 'qqqqqqqqq'}, {'WeigherID': '11', 'xname': 'ttttttt'},]);//	local data for graph or report
	const weighers = useSelector(state => state.weighers);// store main weighers data for this client
	const weighersLoaded = useSelector(state => state.weighersLoaded);//initial load event has completed
	const [weighersList, setWeighersList] = useState([]);//	local data for graph or report
	const [wloading, setWloading] = useState(false);
	const dispatch = useDispatch()
	const { value, cols, setWeigherId, clientId } = props
	//console.log('weighers',weighers)

	const showMessage = useCallback(
		(data) => dispatch(actionSetMessage(data)),
		[dispatch]
	)

	useEffect(() => {// load the weighers from the api if they havent been loaded
		//console.log('clientId', clientId);
		//console.log('weighers debug', weighers)
		//console.log('weighers length', weighers.length)
		if (clientId > 0 && !weighersLoaded){
		//if (clientId > 0){
			//console.log('loading now')
			setWloading(true)	//reset loading flag
			dispatch(actionFetchWeigherIds(clientId, setWloading, showMessage));
		}
	},[weighersLoaded, clientId, showMessage, setWloading, dispatch])

	useEffect(() => {
		const makeWeighersList = () =>{
			if (weighers === null || weighers === undefined){
				return []
			} else {
				const weigherList = weighers.reduce(function (res, set) {
					//console.log('set', set)
					//res.push([...set.WeigherID])
					const displaySet = {WeigherID: set.WeigherID, name: set.name || '' }
					//const displaySet = {WeigherID: set.WeigherID, name: 'aaaaa' }
					res.push(displaySet);
					//res.push(set.WeigherID)
					return res;
				}, []);
				//console.log('weigherList', weigherList)
				return weigherList;
			}
		}
		const weigherList = makeWeighersList(weighers);
		setWeighersList(weigherList)
	},[weighers])

	useEffect(() => {// set the initial default after load
		//console.log('weighers',weighers)
		//console.log('value', value)

		//if (weighers.length >0 && value === ''){
		//if (weighers.length >0){
		if ( weighersList.length > 0 ){
			//handleChange({target: {type: 'text', id: 'Weigher', value: weighers[0]}});//ERROR endless loop
			//console.log('setting weigherId to', weighers[0]);
			setWeigherId(weighersList[0].WeigherID)
		}
	//},[weighers, setWeigherId, value])
	},[weighersList, setWeigherId])

	const handleChange = (evt) =>{
		evt.persist()
		//console.log('setting weigherId to',evt.target.value);
		setWeigherId(evt.target.value)
	}

	//console.log('weighers', weighers)
	//console.log('wloading', wloading)

	if (weighersList.length === 1){
		return (
			<Row className="inputRow">
				<Col sm={ cols.lhs }><label className="dropdownLabel">Weigher: </label></Col>
				<Col sm={ cols.rhs }>
				<strong>{ weighersList[0].name } [id:{ weighersList[0].WeigherID }]</strong>
				{ props.children }
				</Col>
			</Row>
		)
	} else {
		return (
			<Row className="inputRow">
				<Col sm={ cols.lhs }>Weigher:</Col>
				<Col sm={ cols.rhs }>
					{ wloading
						? <Loading loading = {wloading} />
						: (
							<Form.Control
								as="select"
								onChange = {(evt)=>handleChange(evt)}
								value = { value }
							>
								{ weighersList.map((row, idx) =>{
								return (
									<option
										key={idx}
										value={row.WeigherID}
									>{ row.name } [id:{ row.WeigherID }]</option>
								)
								})
							}
						</Form.Control>
						)
					}

				</Col>
				<Col sm={ 2 }>{ props.children }</Col>
			</Row>
		)
	}
}





